import SubsectionHeader from '../components/subsection-header/subsection-header';
import SubsectionFooter from '../components/subsection-footer/subsection-footer';
import CPGKeyMotivator from './cpg-key-motivator';
import CPGSummary from './cpg-summary';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import './cpg.scss';
import { useState, useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

// References for Financial Section
const CPGUsageReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const CPGPlanningReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
];

const CPGIntegrationReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."}
];

const CPGMetricsReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const CPGFutureReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "According to the Association of National Advertisers’ “Response Rate Report 2021: Performance and Cost Metrics.”"},
  {reference: "“<a href='https://www.lob.com/blog/4-direct-mail-marketing-myths-debunked' target='_blank'>4 Direct Mail Marketing Myths Debunked</a>,” Lob, Oct. 4, 2022."}
];

export default function CPG() {

  const url = useLocation();
  const path = url.pathname;
  const segment = path.substring(path.lastIndexOf('/') + 1);
  const currentSection = "CPG";
  const [subsection, setCurrentSubsection] = useState('usage');
  const keyTakeaways = false;

  // Hero Headings
  
  const h1 = "Consumer Packaged Goods&nbsp;<span>(CPG)</span>";
  const h2 = "Direct Mail in the CPG Industry:";
  const subtext = "Key Stats and Insights";
  const heroAlt = "Monochromatic dark purple shapes arranged across a dark purple gridded background.";

// Initial References - Financial Usage 
  const [references, setReferences] = useState(CPGUsageReferences);

  useEffect(() => {

    switch (segment) {
      case "cpg": 
        setReferences(CPGUsageReferences);
        setCurrentSubsection('usage');
        break;
      case "planning": 
        setReferences(CPGPlanningReferences);
        setCurrentSubsection('planning');
        break;
      case "integration": 
        setReferences(CPGIntegrationReferences);
        setCurrentSubsection('integration');
        break;
      case "metrics": 
        setReferences(CPGMetricsReferences);
        setCurrentSubsection('metrics');
        break;
      case "future": 
        setReferences(CPGFutureReferences);
        setCurrentSubsection('future');
        break;
    }
    
  }, [url]);

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [url.pathname]);

  return (
    <>
      <div className={'cpg ' + subsection}>
        <div className='container' data-aos="fade-up">
          <SubsectionHeader currentSection={currentSection} heroAlt={heroAlt} h1={h1} h2={h2} subtext={subtext}/>
          <Outlet />
          <SubsectionFooter currentSection={currentSection} KeyMotivator={CPGKeyMotivator} Summary={CPGSummary} references={references} keyTakeaways={keyTakeaways} />
        </div>
      </div>
    </>
  );
}
